import { useEffect, useState } from "react";
import { postData } from "./Http/api";
import requestVacios from "./Interfaces/requestVacios";

// Hook para componentes que necesitan usuarios con auto-carga
export const useUsuarios = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/UsuarioListar", requestVacios.Usuario());
        setRows(response);
      } catch (ex) {
        console.error(ex);
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Función async para obtener usuarios (sin hook)
export const fetchUsuarios = async () => {
  try {
    const response = await postData("/UsuarioListar", {});
    // El gestor testigo se distingue en los desplegables de gestor (filtros y "Cambiar gestor").
    const data = response?.value?.map((item) => ({
      idUsuario: item.idUsuario,
      nombreCompleto: `${item.nombre || item.usuario}${item.esTestigo ? " (Gestor testigo)" : ""}`,
      usuario: item.usuario,
      activo: item.activo,
      esTestigo: !!item.esTestigo
    })) || [];
    return data;
  } catch (error) {
    console.error("Error fetching usuarios:", error);
    return [];
  }
};

// Export por defecto para compatibilidad con imports antiguos
const Usuarios = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/UsuarioListar", requestVacios.Usuario());
        setRows(response);
      } catch (ex) {
        console.error(ex);
      }
    };

    fetchData();
  }, []);

  return rows;
};

export default Usuarios;

